// extracted by mini-css-extract-plugin
export var measureBox = "_v-0";